__turbopack_context__.v({
  "cookieScreen": "VideoComponent-module-scss-module__ODYYxW__cookieScreen",
  "defaultVariant": "VideoComponent-module-scss-module__ODYYxW__defaultVariant",
  "fullWidthVariant": "VideoComponent-module-scss-module__ODYYxW__fullWidthVariant",
  "titleText": "VideoComponent-module-scss-module__ODYYxW__titleText",
  "videoWrapper": "VideoComponent-module-scss-module__ODYYxW__videoWrapper",
  "youtubeThumbnailWrapper": "VideoComponent-module-scss-module__ODYYxW__youtubeThumbnailWrapper",
});
